




























































































































































































import { Component, Vue } from 'vue-property-decorator'
import { CalendarSettingsInterface } from '@plugin/Common/interfaces/calendar-settings.interface'
import { aspenwareCommerceSettingsService } from '@plugin/Common/services/aspenware-commerce-settings.service'

@Component({})
export default class AdminPricingCalendar extends Vue {
  private settings: CalendarSettingsInterface | null = null
  private loading: boolean = false

  async created() {
    this.settings = await aspenwareCommerceSettingsService.getCalendarSettings()
  }

  async updateCalendarSettings() {
    if (this.settings) {
      this.loading = true
      await aspenwareCommerceSettingsService.updateCalendarSettings(this.settings)
      this.loading = false
    }
  }
}
